import { Injectable } from "@angular/core";
import { Product } from "../../products/interfaces/products.interface";
import { ProductData } from "../../list-products/interfaces/list-products-new.interface";

@Injectable({
  providedIn: 'root'
})
export class SearchProductsService {

  private products: ProductData[] = [];

  constructor() { }

  setProducts(products: ProductData[]): void {
    this.products = products;
  }

  getProducts(): ProductData[] {
    return this.products;
  }

  searchProducts(term: string): ProductData[] {
    if (!term.trim()) {
      return [];
    }
    const normalizedTerm = term.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    return this.products.filter(product => {
      const normalizedName = product.pd_name.toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

      return normalizedName.includes(normalizedTerm);
    });
  }
}
